import {
  SubscriptionBillingPeriod,
  SubscriptionTier,
} from '@/types/subscription';
import { UserCurrency } from '@/types/user';

export const STORAGE_KEYS = {
  POST_SETUP_NUDGE_SHOWN: 'post-setup-nudge-shown',
  SHOW_POST_SETUP_NUDGE: 'show-post-setup-nudge',

  CREATE_ORG_MODAL_SHOWN: 'create-org-modal-shown',

  SSO_FLOW_TYPE: 'sso-flow-type',

  CURRENCY: 'currency',

  TIER: 'tier',
  BILLING_PERIOD: 'billing-period',

  CONSENT_SESSION_ID: 'consent-session-id',

  COURSES_TOOL_VERSIONS: 'courses-tool-versions',
  COURSES_CHAT_CONVERSATIONS: 'courses-chat-conversations',
  COURSE_DETAILS_ACCORDION: 'course-details-accordion',

  HOME_WELCOME_DISMISSED: 'home-welcome-dismissed',

  REFERRAL_ATTRIBUTION: 'referral-attribution',
} as const;

export const setShowPostSetupNudge = (): void => {
  sessionStorage.setItem(STORAGE_KEYS.SHOW_POST_SETUP_NUDGE, 'true');
};

export const isHomeWelcomeDismissed = (): boolean =>
  localStorage.getItem(STORAGE_KEYS.HOME_WELCOME_DISMISSED) === 'true';

export const markHomeWelcomeDismissed = (): void => {
  localStorage.setItem(STORAGE_KEYS.HOME_WELCOME_DISMISSED, 'true');
};

export const getSubscriptionPreferences = (): {
  selectedTier: SubscriptionTier;
  selectedBillingPeriod: SubscriptionBillingPeriod;
  userCurrency: UserCurrency;
} => {
  const selectedTier = sessionStorage.getItem(
    STORAGE_KEYS.TIER
  ) as SubscriptionTier;
  const selectedBillingPeriod = sessionStorage.getItem(
    STORAGE_KEYS.BILLING_PERIOD
  ) as SubscriptionBillingPeriod;
  const userCurrency = sessionStorage.getItem(
    STORAGE_KEYS.CURRENCY
  ) as UserCurrency;

  return {
    selectedTier,
    selectedBillingPeriod,
    userCurrency,
  };
};
